import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import Avatar from 'Components/ComponentLibrary/Atoms/Avatar';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: theme.radius.sm,
    width: '100%',
  },
  avatarContainer: {
    display: 'flex',
    flexBasis: '3/10',
    alignContent: 'center',
    justifyContent: 'center',
  },
  avatar: {},
  hidden: {
    display: 'none',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexGrow: 1,
    flexWrap: 'wrap',
    '& *': {
      flexBasis: '100%',
    },
  },
  icon: {
    minWidth: 0,
  },
});

const Card = ({
  className,
  classes,
  onClick,
  primaryText,
  secondaryText,
  avatar,
  ActionIcon,
}) => {
  return (
    <Box
      onClick={onClick}
      className={classNames(classes.root, className)}
      component={onClick ? Button : 'div'}
      endIcon={onClick ? <ActionIcon color="primary" fontSize="lg" /> : null}
    >
      <Box className={classNames(classes.avatarContainer, { [classes.hidden]: !avatar })}>
        <Avatar className={classes.avatar}>
          {avatar}
        </Avatar>
      </Box>
      <Box className={classes.textContainer} p={1}>
        <Subtitle text={primaryText} align="left" />
        <BodyText text={secondaryText} align="left" />
      </Box>
    </Box>
  );
};

Card.defaultProps = {
  className: '',
  onClick: undefined,
  ActionIcon: KeyboardArrowRightIcon,
  avatar: null,
  primaryText: '',
  secondaryText: '',
};

Card.propTypes = {
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  avatar: PropTypes.node,
  ActionIcon: PropTypes.node,
};

export default withStyles(styles)(Card);
